import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconDelete = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      fill="none"
      viewBox="0 0 28 28"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 6H7L7 22H21V6ZM5 4V22C5 23.1046 5.89543 24 7 24H21C22.1046 24 23 23.1046 23 22V4H5Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M24 6H4V4H24V6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M18 5H10V3H18V5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 20V8H12V20H10Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 20V8H18V20H16Z" fill="currentColor" />
    </SvgIcon>
  );
};
